import { Base } from "../../../../core/db/models/index";
import { OrderItemLike } from "./orderItem";
import { MeasuringTypeLike } from "./index";
import FortumDatabase from "../../index";
import { WithAllType, arrayOrCollection } from "../../../../core/db/index";
import { CleansingInstanceLike, CleansingInstance } from "./cleansingTypeusage";
import { OfflineMixin } from "./order";


export interface MeasurementLike extends Base, OfflineMixin
{
    value_before: number;
    value_after: number;
    item_id: number;
    // Nullable
    cleansing_instance_id?: number;
    type_id: number;
    cleansing_instance?: CleansingInstanceLike;
    item?: OrderItemLike;
    type?: MeasuringTypeLike;
    is_incomplete: boolean;
    operator_notes: string;
}

export class Measurement implements Partial<MeasurementLike>
{
    public static readonly KIND_BEFORE_CLEANSING = 'before_cleansing';
    public static readonly KIND_AFTER_CLEANSING = 'after_cleansing';

    public static withAll(db: FortumDatabase, targetMeasurements: WithAllType<MeasurementLike>): PromiseLike<MeasurementLike[]>
    {
        let measurements: MeasurementLike[];
        return arrayOrCollection(targetMeasurements).then((resolvedMeasurements) =>
        {
            measurements = resolvedMeasurements;

            return Promise.all([
                db.DeconMeasuringType.where('id').anyOf(measurements.map(o => o.type_id)).toArray(),
                db.DeconOrderItem.where('id').anyOf(measurements.filter(o => o.item_id != null).map(o => o.item_id)).toArray(),
            ]);
        }).then((results) =>
        {
            let types: MeasuringTypeLike[] = results[0];
            let orderItems: OrderItemLike[] = results[1];

            for(let measurement of measurements)
            {
                measurement.type = types.find(o => o.id == measurement.type_id);
                if (measurement.item == null)
                {
                    measurement.item = orderItems.find(o => o.id == measurement.item_id);
                }

            }
        }).then(() =>
        {
            return measurements;
        }); 
    }

    public static isValid(valueBefore: number, valueAfter: number, allowIncomplete = false)
    {
        // Measurement must have either both values or after value.

        if (valueBefore != null && valueAfter != null && valueAfter <= valueBefore)
        {
            return true;
        }
        else if(valueBefore != null && valueAfter == null && allowIncomplete)
        {
            return true;
        }
        else if(valueBefore == null && valueAfter != null)
        {
            return true;
        }
        
        return false;
    }

    public static isValidStrict(valueBefore: number, valueAfter: number)
    {
        return valueBefore != null && valueAfter != null;
    }

    public static isIncomplete(valueBefore: number, valueAfter: number)
    {
        if ((valueBefore == null && valueAfter == null) || (valueBefore != null && valueAfter == null))
        {
            return true;
        }

        return false;
    }
}   